import { Sidebar } from '@builder';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import { COMMON_TRANSLATION } from '@constants/index';
import {
  CommunityOutreachIcon,
  GeneticCounselingIcon,
  MainLayoutWrapperStyled,
  StudyInsightsIconStyled,
  HrnWithdrawalStyled,
} from './MainLayout.styles';
import { HeaderLarge } from '@modules/core/components';
import { IdItem, MainLayoutProps } from './MainLayout.types';
import { PATHS } from '@constants/routes';
import { Permissions } from '@modules/permissions/types';
import { SidebarItem } from '@/common/components/builder/organisms/Sidebar/Sidebar.types';
import { useAuth } from '@modules/auth/hooks';
import { useAuthStore } from '@/modules/auth/store';
import { usePermissions } from '@modules/permissions/hooks';

const MainLayout: FC<MainLayoutProps> = ({ hasPrimaryHeader, hasPrimarySidebar }) => {
  const { t } = useTranslation(COMMON_TRANSLATION);
  const { isAuthenticated } = useAuth();
  const { user: currentUser } = useAuthStore();
  const { hasPermission } = usePermissions();

  const location = useLocation();

  const items: SidebarItem[] = [
    {
      id: IdItem.STUDY_INSIGHTS,
      icon: <StudyInsightsIconStyled />,
      label: t('sidebar.study_insights'),
      url: PATHS.STUDY_INSIGHTS,
    },
  ];

  if (currentUser !== null) {
    if (hasPermission(Permissions.COMMUNITY_OUTREACH)) {
      items.push({
        id: IdItem.COMMUNITY_OUTREACH,
        icon: <CommunityOutreachIcon />,
        label: t('sidebar.community_outreach'),
        url: PATHS.COMMUNITY_OUTREACH,
      });
    }

    if (hasPermission(Permissions.GENETIC_COUNSELING)) {
      items.push({
        id: IdItem.GENETIC_COUNSELING,
        icon: <GeneticCounselingIcon />,
        label: t('sidebar.genetic_counseling'),
        url: `${PATHS.GENETIC_COUNSELING.ROOT}`,
      });
    }

    items.push({
      id: IdItem.HRN_WITHDRAWAL,
      icon: <HrnWithdrawalStyled />,
      label: t('sidebar.hrn_withdrawal'),
      url: `${PATHS.HRN_WITHDRAWAL}`,
    });
  }

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [location.pathname]);

  return (
    <MainLayoutWrapperStyled>
      {hasPrimarySidebar !== undefined && hasPrimarySidebar && (
        <Sidebar locationPath={location.pathname} menuItems={items} />
      )}
      {hasPrimaryHeader !== undefined && hasPrimaryHeader && isAuthenticated === true && <HeaderLarge />}
      <Outlet />
    </MainLayoutWrapperStyled>
  );
};

export default MainLayout;
